import { render, staticRenderFns } from "./Rectangle.vue?vue&type=template&id=c5101334&scoped=true&"
import script from "./Rectangle.vue?vue&type=script&lang=js&"
export * from "./Rectangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5101334",
  null
  
)

export default component.exports